export class NoteAddModel{
    public id: number;
    public accessGroupId: number;
    public noteText: string;
    public isPinnedNote: boolean;
    public attachment: File;
    public date: string;
    public module: number;
    public entityId: string;
    public isCurrentUser: boolean;
}